<template>
  <ins v-if="isReady" class="adsbygoogle"
        :id="id"
        :style="style"
       data-ad-client="ca-pub-1584834014713867"
       :data-ad-slot="adSlot"
       data-ad-format="auto"
       data-full-width-responsive="true"></ins>
</template>

<script>
export default {
  name: 'googleAd',
  props: {
    id: { type: String, required: true },
    adSlot: { type: String, required: true },
    style: {
      type: String,
      default: 'display:block;width:100%'
    }
  },
  data() {
    return {
      isReady: false
    };
  },
  mounted() {
    try {
        this.isReady=true
      this.$nextTick(() => {
            setTimeout(() => {
            try {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            } catch (e) {
                console.error("AdSense error:", e);
            }
            }, 500); // slight delay to ensure DOM and data are stable
        });
    } catch (e) {
      console.error("AdSense error", e);
    }
  }
}
</script>
